<template>
  <div style="min-height: 400px;">

    <!--汇总-->
    <Total style="min-height: 450px;"></Total>
    <!--交易统计-->
    <Transaction></Transaction>
    <!-- 商户统计 -->
    <!-- <SalesAnalysis style="min-height: 450px;"></SalesAnalysis> -->

    <!--商品统计-->
    <!-- <Product></Product> -->
  </div>
</template>

<script>
import StatisticsApi from "@/api/statistics.js";
import Total from "./part/Total.vue";
import Transaction from "./part/Transaction.vue";
// import Product from "./part/Product.vue";
// import SalesAnalysis from "./part/SalesAnalysis.vue";

export default {
  components: {
    Total,
    Transaction
    // Product
    // SalesAnalysis
  },
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*数据对象*/
      dataModel: {}
    };
  },
  // provide: function() {
  //   return {
  //     dataModel: this.dataModel
  //   };
  // },
  created() {
    // this.getData();
  },
  methods: {
    /*获取数据*/
    getData() {
      let self = this;
      StatisticsApi.getOrderTotal({}, true)
        .then(res => {
          Object.assign(self.dataModel, res.data);
          self.loading = false;
        })
        .catch(error => {});
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/statistics/sales/index.vue